import React, { useEffect, useState } from "react";
import {
    getPlacedReport, getAwaitingReport, getJobRequirementReport, getJobRequirementDetails,
    getPlacedStudentsDetails, getPlacedByReport
} from "../services/reportService";
import PlacedChart from "../components/reports/PlacedChart";
import AwaitingPieChart from "../components/reports/AwaitingPieChart";
import ReportFiltersPanel from "../components/reports/ReportFiltersPanel";
import ReportFilterSummary from "../components/reports/ReportFilterSummary";
import ProfileAvatarpp from "../components/common/Avatar/ProfileAvatarpp";
import UserProfileDropdown from "../components/common/Avatar/UserProfileDropdown";
import PlacedTable from "../components/reports/PlacedTable";
import { useToast } from '../components/Admissionform/ToastManager';
import JobRequirementChart from "../components/reports/JobRequirementChart";
import JobRequirementTable from "../components/reports/JobRequirementTable";
import PlacedByChart from "../components/reports/PlacedByChart";
import PlacedByTable from "../components/reports/PlacedByTable";

// ✅ Import same styles
import "../styles/Placementdb.css";
import "../styles/ReportsDashboard.css";
import AwaitingTable from "../components/reports/AwaitingTable";

const ReportsDashboard = () => {
    const [placedData, setPlacedData] = useState([]);
    const [awaitingData, setAwaitingData] = useState([]);
    const [branches, setBranches] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [courses, setCourses] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectedPlacedBy, setSelectedPlacedBy] = useState([]);
    const [packageRange, setPackageRange] = useState("");
    const [placementDateFrom, setPlacementDateFrom] = useState("");
    const [placementDateTo, setPlacementDateTo] = useState("");
    const [placementStatusFilter, setPlacementStatusFilter] = useState("All");
    const [placementOfficers, setPlacementOfficers] = useState([]);
    const { showError } = useToast();
    const [jobRequirementData, setJobRequirementData] = useState([]);
    const [jobDetails, setJobDetails] = useState([]);
    const [showJobDetails, setShowJobDetails] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [placedDetails, setPlacedDetails] = useState([]);
    const [showPlacedDetails, setShowPlacedDetails] = useState(false);
    const [placedByData, setPlacedByData] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [branchData, setBranchData] = useState([]);
    const handleViewJobDetails = async (month) => {

        try {

            setSelectedMonth(month);

            const filters = {
                createdBy:
                    selectedPlacedBy.join(","),

                department:
                    selectedDepartments.join(","),

                createdDateFrom:
                    placementDateFrom,

                createdDateTo:
                    placementDateTo,

                month
            };

            const res =
                await getJobRequirementDetails(filters);

            setJobDetails(res.data || []);

            setShowJobDetails(true);

        } catch (err) {

            console.error(
                "Error fetching job details",
                err
            );
        }
    };
    const handleViewPlacedDetails = async (
        month
    ) => {

        try {

            setSelectedMonth(month);

            const filters = {
                branches:
                    selectedBranches.join(","),

                departments:
                    selectedDepartments.join(","),

                courseNames:
                    selectedCourses.join(","),

                placedBy:
                    selectedPlacedBy.join(","),

                packageRange,

                placementDateFrom,

                placementDateTo,

                placementStatusFilter,

                month
            };

            const res =
                await getPlacedStudentsDetails(
                    filters
                );

            setPlacedDetails(res.data || []);

            setShowPlacedDetails(true);

        } catch (err) {

            console.error(
                "Error fetching placed details",
                err
            );
        }
    };
    useEffect(() => {

        if (!showJobDetails || !selectedMonth) return;

        const fetchFilteredJobDetails = async () => {

            try {

                const filters = {
                    createdBy:
                        selectedPlacedBy.join(","),

                    department:
                        selectedDepartments.join(","),

                    createdDateFrom:
                        placementDateFrom,

                    createdDateTo:
                        placementDateTo,

                    month: selectedMonth
                };

                const res =
                    await getJobRequirementDetails(filters);

                setJobDetails(res.data || []);

            } catch (err) {

                console.error(
                    "Error refreshing job details",
                    err
                );
            }
        };

        fetchFilteredJobDetails();

    }, [
        selectedPlacedBy,
        selectedDepartments,
        placementDateFrom,
        placementDateTo,
        selectedMonth,
        showJobDetails
    ]);

    useEffect(() => {

        const fetchBranches = async () => {

            try {

                const token = localStorage.getItem("token");

                const res = await fetch(
                    `${process.env.REACT_APP_API_URL}/location`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                const data = await res.json();

                const activeBranches = data.filter(
                    item => item.status === true
                );

                setBranchData(activeBranches);

                // ✅ Branch list
                const uniqueBranches = [
                    ...new Set(
                        activeBranches.map(item => item.branch)
                    )
                ];

                setBranches(uniqueBranches);

                // ✅ Location list
                const uniqueLocations = [
                    ...new Set(
                        activeBranches.map(item => item.location)
                    )
                ];

                setLocations(uniqueLocations);

            } catch (err) {

                console.error("Branch fetch error", err);
            }
        };

        fetchBranches();

    }, []);
    useEffect(() => {

        if (selectedLocations.length === 0) {
            return;
        }

        const filteredBranches = branchData
            .filter(item =>
                selectedLocations.includes(item.location)
            )
            .map(item => item.branch);

        const uniqueBranches = [...new Set(filteredBranches)];

        setSelectedBranches(uniqueBranches);

    }, [selectedLocations, branchData]);
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const token = localStorage.getItem("token");

                const res = await fetch(`${process.env.REACT_APP_API_URL}/alltech`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                const data = await res.json();

                const uniqueDepartments = [...new Set(
                    data.data.map(item => item.Department)
                )];

                setDepartments(uniqueDepartments);
            } catch (err) {
                console.error("Department fetch error", err);
            }
        };

        fetchDepartments();
    }, []);
    useEffect(() => {
        const fetchCourses = async () => {
            if (selectedDepartments.length === 0) {
                setCourses([]);
                return;
            }

            try {
                const token = localStorage.getItem("token");

                const res = await fetch(
                    `${process.env.REACT_APP_API_URL}/course-by-department?Department=${selectedDepartments[0]}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                const data = await res.json();

                setCourses(data.courses || []);
            } catch (err) {
                console.error("Course fetch error", err);
            }
        };

        fetchCourses();
    }, [selectedDepartments]);
    useEffect(() => {
        const fetchPlacementOfficers = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${process.env.REACT_APP_API_URL}/employees`, {
                    method: 'GET',
                    headers: {
                        ...(token && { 'Authorization': `Bearer ${token}` }),
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    const result = await response.json();
                    if (Array.isArray(result)) {
                        setPlacementOfficers(result);
                    }
                }
            } catch (error) {
                console.error('Error fetching placement officers:', error);
                showError('Error loading placement officers.');
            }
        };

        fetchPlacementOfficers();
    }, [showError]);

    const handleApplyFilters = async () => {
        const filters = {
            branches: selectedBranches.join(","),
            departments: selectedDepartments.join(","),
            courseNames: selectedCourses.join(","),

            // ✅ placed report
            placedBy: selectedPlacedBy.join(","),

            // ✅ job requirement report
            createdBy: selectedPlacedBy.join(","),

            packageRange,

            // ✅ placed report dates
            placementDateFrom,
            placementDateTo,

            // ✅ job requirement report dates
            createdDateFrom: placementDateFrom,
            createdDateTo: placementDateTo,

            placementStatusFilter
        };
        try {
            const placedRes = await getPlacedReport(filters);
            const awaitingRes = await getAwaitingReport(filters);
            const jobReqRes = await getJobRequirementReport(filters);
            const placedByRes = await getPlacedByReport(filters);

            setPlacedByData(placedByRes.data || []);
            setPlacedData(placedRes.data || []);
            setAwaitingData(awaitingRes.data || []);
            setJobRequirementData(jobReqRes.data || []);
        } catch (err) {
            console.error("Error applying filters", err);
        }
    };

    const handleClear = async () => {
        // reset UI
        setSelectedLocations([]);
        setSelectedBranches([]);
        setSelectedDepartments([]);
        setSelectedCourses([]);
        setSelectedPlacedBy([]);
        setPackageRange("");
        setPlacementDateFrom("");
        setPlacementDateTo("");
        setPlacementStatusFilter("All");

        // call API with fresh empty filters
        try {
            const placedRes = await getPlacedReport({});
            const awaitingRes = await getAwaitingReport({});
            const placedByRes = await getPlacedByReport({});

            setPlacedByData(placedByRes.data || []);
            setPlacedData(placedRes.data || []);
            setAwaitingData(awaitingRes.data || []);
        } catch (err) {
            console.error("Error resetting reports", err);
        }
    };

    // 🔄 Fetch data
    const fetchReports = async () => {
        try {
            const filters = {
                placementStatusFilter: "All"
            };

            const placedRes = await getPlacedReport(filters);
            const awaitingRes = await getAwaitingReport(filters);
            const jobReqRes = await getJobRequirementReport(filters);
            const placedByRes = await getPlacedByReport(filters);

            setPlacedByData(placedByRes.data || []);
            setPlacedData(placedRes.data || []);
            setAwaitingData(awaitingRes.data || []);
            setJobRequirementData(jobReqRes.data || []);
        } catch (err) {
            console.error("Error resetting reports", err);
        }
    };

    useEffect(() => {
        fetchReports();
    }, []);

    useEffect(() => {
        const filters = {
            branches: selectedBranches.join(","),
            departments: selectedDepartments.join(","),
            courseNames: selectedCourses.join(","),

            // ✅ placed report
            placedBy: selectedPlacedBy.join(","),

            // ✅ job requirement report
            createdBy: selectedPlacedBy.join(","),

            packageRange,

            // ✅ placed report dates
            placementDateFrom,
            placementDateTo,

            // ✅ job requirement report dates
            createdDateFrom: placementDateFrom,
            createdDateTo: placementDateTo,

            placementStatusFilter
        };

        const fetchData = async () => {
            try {
                const placedRes = await getPlacedReport(filters);
                const awaitingRes = await getAwaitingReport(filters);
                const jobReqRes = await getJobRequirementReport(filters);
                const placedByRes = await getPlacedByReport(filters);

                setPlacedData(placedRes.data || []);
                setAwaitingData(awaitingRes.data || []);
                setJobRequirementData(jobReqRes.data || []);
                setPlacedByData(placedByRes.data || []);
            } catch (err) {
                console.error("Error fetching reports", err);
            }
        };

        fetchData();
    }, [
        selectedBranches,
        selectedDepartments,
        selectedCourses,
        selectedPlacedBy,
        packageRange,
        placementDateFrom,
        placementDateTo,
        placementStatusFilter
    ]);

    return (
        <div className="dashboard reports-dashboard">

            {/* ✅ HEADER SAME AS Placementdb */}
            <div className="dashboard-header">
                <h1 className="dashboard-heading">
                    REPORTS DASHBOARD
                </h1>

                <div className="flex items-center gap-4">
                    <UserProfileDropdown />
                    <ProfileAvatarpp />
                </div>
            </div>

            {/* ✅ FILTER SECTION */}
            <div className="head">
                <h3>Filter Reports</h3>
            </div>

            <ReportFilterSummary
                selectedLocations={selectedLocations}
                setSelectedLocations={setSelectedLocations}
                selectedBranches={selectedBranches}
                selectedDepartments={selectedDepartments}
                selectedCourses={selectedCourses}
                selectedPlacedBy={selectedPlacedBy}
                packageRange={packageRange}
                placementDateFrom={placementDateFrom}
                placementDateTo={placementDateTo}
                placementStatusFilter={placementStatusFilter}

                setSelectedBranches={setSelectedBranches}
                setSelectedDepartments={setSelectedDepartments}
                setSelectedCourses={setSelectedCourses}
                setSelectedPlacedBy={setSelectedPlacedBy}
                setPackageRange={setPackageRange}
                setPlacementDateFrom={setPlacementDateFrom}
                setPlacementDateTo={setPlacementDateTo}
                setPlacementStatusFilter={setPlacementStatusFilter}
            />
            <ReportFiltersPanel
                locations={locations}
                selectedLocations={selectedLocations}
                setSelectedLocations={setSelectedLocations}
                branches={branches}
                departments={departments}
                courses={courses}

                selectedBranches={selectedBranches}
                selectedDepartments={selectedDepartments}
                selectedCourses={selectedCourses}
                placementOfficers={placementOfficers}

                setSelectedBranches={setSelectedBranches}
                setSelectedDepartments={setSelectedDepartments}
                setSelectedCourses={setSelectedCourses}

                selectedPlacedBy={selectedPlacedBy}
                setSelectedPlacedBy={setSelectedPlacedBy}
                packageRange={packageRange}
                setPackageRange={setPackageRange}
                placementDateFrom={placementDateFrom}
                setPlacementDateFrom={setPlacementDateFrom}
                placementDateTo={placementDateTo}
                setPlacementDateTo={setPlacementDateTo}
                placementStatusFilter={placementStatusFilter}
                setPlacementStatusFilter={setPlacementStatusFilter}

                onApply={handleApplyFilters}
                onClear={handleClear}
            />

            {/* ✅ CHARTS SECTION */}
            <div className="report-row">
                <div className="report-chart">
                    <PlacedChart data={placedData} />
                </div>

                <div className="report-table">
                    <PlacedTable
                        data={placedData}
                        onViewDetails={
                            handleViewPlacedDetails
                        }
                    />                </div>
            </div>
            {showPlacedDetails && (
                <div className="job-details-container">

                    <div className="job-details-header">

                        <h3>
                            Placed Students - {selectedMonth}
                        </h3>

                        <button
                            className="close-job-details-btn"
                            onClick={() => {

                                setShowPlacedDetails(false);

                                setPlacedDetails([]);

                                setSelectedMonth("");
                            }}
                        >
                            ✕ Close
                        </button>

                    </div>

                    <table className="job-details-table">

                        <thead>
                            <tr>
                                <th>Student Name</th>
                                <th>Branch</th>
                                <th>Department</th>
                                <th>Placement Status</th>
                                <th>Placed By</th>
                                <th>Company</th>
                                <th>Package</th>
                                <th>Placement Date</th>
                                <th>Verification Status</th>
                            </tr>
                        </thead>

                        <tbody>

                            {[...placedDetails]
                                .sort((a, b) => {

                                    const departmentOrder = [
                                        "IT",
                                        "SAP",
                                        "Multimedia / UIUX",
                                        "Embedded/PCB/IOT",
                                        "Mech",
                                        "MEP",
                                        "Civil",
                                        "Automation",
                                        "Digital Marketing",
                                        "VLSI",
                                        "Piping Design"
                                    ];

                                    return (
                                        departmentOrder.indexOf(a.Department) -
                                        departmentOrder.indexOf(b.Department)
                                    );
                                })
                                .map((student, index) => (

                                    <tr key={index}>

                                        <td>
                                            <div style={{ fontWeight: "600" }}>
                                                {student.studentName}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#666",
                                                    marginTop: "2px"
                                                }}
                                            >
                                                {student.courseName}
                                            </div>
                                        </td>
                                        <td>{student.branch}</td>

                                        <td>{student.Department}</td>
                                        <td title={student.placementRemarks || "No Remarks"}>
                                            {student.placementStatus}
                                        </td>
                                        <td>{student.placedBy}</td>

                                        <td>{student.companyName}</td>

                                        <td>
                                            ₹{
                                                Number(
                                                    student.package || 0
                                                ).toLocaleString("en-IN")
                                            }
                                        </td>

                                        <td>{student.placementDate}</td>
                                        <td title={student.verificationRemarks || "No Remarks"}>
                                            {student.joiningStatus}
                                        </td>

                                    </tr>
                                ))}

                        </tbody>

                    </table>

                </div>
            )}

            <div className="report-row">
                <div className="report-chart">
                    <AwaitingPieChart data={awaitingData} />
                </div>

                <div className="report-table">
                    <AwaitingTable data={awaitingData} />
                </div>
            </div>
            <div className="report-row">
                <div className="report-chart">
                    <JobRequirementChart data={jobRequirementData} />
                </div>

                <div className="report-table">
                    <JobRequirementTable data={jobRequirementData} onViewDetails={handleViewJobDetails} />
                </div>
            </div>
            {showJobDetails && (
                <div className="job-details-container">
                    <div className="job-details-header">

                        <h3>
                            Job Details - {selectedMonth}
                        </h3>

                        <button
                            className="close-job-details-btn"
                            onClick={() => {

                                setShowJobDetails(false);

                                setJobDetails([]);

                                setSelectedMonth("");
                            }}
                        >
                            ✕ Close
                        </button>

                    </div>

                    <table className="job-details-table">

                        <thead>
                            <tr>
                                <th>Job ID</th>
                                <th>Company</th>
                                <th>Job Title</th>
                                <th>Created By</th>
                                <th>Status</th>
                                <th>Created Date</th>
                                <th>Job Age</th>
                            </tr>
                        </thead>

                        <tbody>

                            {jobDetails.map((job, index) => (

                                <tr key={index}>

                                    <td>{job.jobReqId}</td>

                                    <td>{job.companyName}</td>

                                    <td>{job.jobTitle}</td>

                                    <td>{job.createdBy}</td>

                                    <td
                                        className={
                                            job.jobReqStatus === "Open"
                                                ? "job-status-open"
                                                : "job-status-freeze"
                                        }
                                    >
                                        {job.jobReqStatus}
                                    </td>

                                    <td>{job.createdDate}</td>

                                    <td>
                                        {job.jobAge != null
                                            ? `${job.jobAge} days`
                                            : "-"
                                        }
                                    </td>
                                </tr>
                            ))}

                        </tbody>

                    </table>

                </div>
            )}
            <div className="report-row">
                <div className="report-chart">

                    <PlacedByChart
                        data={placedByData}
                    />
                </div>

            </div>


            <div className="report-table">

                <PlacedByTable
                    data={placedByData}
                />

            </div>
        </div>
    );
};

export default ReportsDashboard;